import React from "react";

/* Circled "i" — advisory and degraded-state notices. */
export const InfoIcon = ({ size = 16, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <circle cx="8" cy="8" r="6.6" stroke="currentColor" strokeWidth="1.4" />
    <path d="M8 7.2v4M8 4.9v.9" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

export default InfoIcon;
